import { Component, OnInit } from '@angular/core';
import {InvoiceTemplateBase} from '../invoce-template-base';

@Component({
  selector: 'eci-packing-list-form',
  templateUrl: './packing-list-form.component.html',
  styleUrls: ['./packing-list-form.component.scss']
})
export class PackingListFormComponent extends InvoiceTemplateBase implements OnInit {


  ngOnInit(): void {
      this.model = {
          ...this.template,
          ...this.invoice,
          customerCompany: {
              ...this.template.customerCompany,
              ...this.invoice.customerCompany
          }
      };

      if (!this.model.labels.cocNr) {
          this.model.labels['cocNr'] = 'COC NR:'
      }
  }

}
